import {
  accountUsersList,
  accountUsersPartialUpdate,
  accountUsersChangePassword,
  accountUsersRemoveOrganization,
  accountUsersBulkRemoveOrganization,
  accountRequestResetPasswordCreate,
  accountResetPasswordCreate,
  type UserUpdateInputBody,
  type UserPasswordUpdate,
  type AccountRequestResetPasswordCreateBody,
  type AccountResetPasswordCreateBody,
  type BulkRemoveOrgRequest,
  type RemoveOrgRequest,
  type User
} from './types/api.generated';
import { accountUsersPartialUpdateResponse } from './types/schemas.zod';

const updateUser = async (userId: number, userData: UserUpdateInputBody): Promise<User | undefined> => {
  const response = await accountUsersPartialUpdate(userId, userData);
  const validatedResponse = accountUsersPartialUpdateResponse.parse(response.data);
  if (response.status === 200) {
    return validatedResponse.data.user;
  }
};

const changePassword = async (userId: number, old_password: string, password: string): Promise<void> => {
  const passwordData: UserPasswordUpdate = { old_password, password };
  await accountUsersChangePassword(userId, passwordData);
};

const removeOrganization = async (userId: number, orgId: number): Promise<void> => {
  const removeOrgData: RemoveOrgRequest = { org_id: orgId };
  await accountUsersRemoveOrganization(userId, removeOrgData);
};

const bulkRemoveOrganization = async (userIds: string[], orgId: number): Promise<void> => {
  const bulkRemoveData: BulkRemoveOrgRequest = {
    ids: userIds.map((id) => parseInt(id, 10)),
    org_id: orgId
  };
  await accountUsersBulkRemoveOrganization(bulkRemoveData);
};

const sendResetPasswordEmail = async (email: string): Promise<void> => {
  const resetData: AccountRequestResetPasswordCreateBody = { email };
  await accountRequestResetPasswordCreate(resetData);
};

const resetPasswordRequest = async (token: string, new_password: string): Promise<void> => {
  const resetData: AccountResetPasswordCreateBody = { token, new_password };
  await accountResetPasswordCreate(resetData);
};

export const UserService = {
  updateUser,
  changePassword,
  removeOrganization,
  bulkRemoveOrganization,
  sendResetPasswordEmail,
  resetPasswordRequest
};
